module.exports = __webpack_public_path__ + "img/statistic.2b3ae4fe.png";